import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { Features } from '../../business-entities/user-role-view-model';
import { AppointmentService } from '../../business-services/appointment.service';
import { DMSSyncFailedlogService } from '../../business-services/dms-sync-failed-log.service';
import { RolesRightsService } from '../../business-services/roles-rights.service';
import { CardCountViewModel, DashboardCardDetailViewModel, DashboardCardResponseModel, DealerWithNoAppointmentsResponseModel } from './../../business-entities/card-count-view-model';
import { DashboardService } from './../../business-services/dashboard.service';
import { LicenseKeyValidationComponent } from './license-key-validation/license-key-validation.component';
import { ExceptionLogService } from '../../business-services/exception-log.service';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker'; 
import { ToastrService } from 'ngx-toastr';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: 'dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  dateDealerWithNoAppointmentRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });
  selectedDealerWithNoAppointmentDate: any[] = [];
  cardCounts: CardCountViewModel;
  cardList: DashboardCardDetailViewModel[];
  cardRows = [];
  userRole: number;
  isDealerLoggedIn: boolean;
  isReceptionLoggedIn: boolean;
  isRentalService: boolean = false;
  features: Features[] = [];
  dashboardDetail: DashboardCardResponseModel;
  dealerList: any[] = [];
  dropdownSettings: {};
  selectedDealers: {dealerId:string, dealerName:string}[] = [];
  isShowAfxSyncErrors: boolean;
  isShowDmsSyncErrors: boolean;
  isShowWidgetAppointmentRequests: boolean;
  isShowDealers: boolean;
  isShowUsers: boolean;
  isShowRentalCars: boolean;
  isShowNotification: boolean;
  buttons = [
    { text: '1D', isClicked: false },
    { text: '7D', isClicked: false },
    { text: '1M', isClicked: false },
    { text: '3M', isClicked: true },
    { text: '6M', isClicked: false },
    { text: '1Y', isClicked: false },
];
barChartButtons = [
  { text: '1M', isClicked: true },
  { text: '2M', isClicked: false },
  { text: '3M', isClicked: false },
  { text: '4M', isClicked: false },
  { text: '5M', isClicked: false },
  { text: '6M', isClicked: false },
];
MonthlyCount = [];
WeeklyCount = [];
SelectedData = [];
monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];
dayNames = ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"];
plannerTotal:number = 0;
widgetTotal:number = 0;
dmsTotal:number = 0;
olbBoTotal:number = 0;
checkedInTotal:number = 0;
invoiceAmountTotal:number = 0;
isShowContactUsers:boolean;
isShowNumberOfDealerWithNoAppointment:boolean = false;
isShowExceptionLog:boolean = false;
isDmsAppointmentActive:boolean = false;
HideDashboardFeatures:string = "";
DMSFeature:boolean = true;
CheckInFeature:boolean = true;
OrderInvoiceAmountFeature:boolean = true;
WorkshopCapacityFeature:boolean = true;
SmartPlannerFeature:boolean = true;
WidgetFeature:boolean = true;
serviceTime:number = 0;
plannedTime:number = 0;
allocatedTime:number = 0;
SyncCounts:any;
isMg = false;
SelectMonthBrandWiseAppointment:string = "";
dealersCountWithNoAppointments:number = 0;
dealersCountWithAppointments:number = 0;
dealersAppointmentCountList:DealerWithNoAppointmentsResponseModel[] = [];

  constructor(
    private dashboardService: DashboardService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private translate: TranslateService,
    private appointmentService: AppointmentService,
    private userService: UserDataService,
    private secureStorage: SecureStorage,
    public datepipe: DatePipe,
    private cookieservice: CookieService,
    private modalService: NgbModal,
    private logService: DMSSyncFailedlogService,
    private toaster: ToastrService,
    private excelService: ExcelService,
    private rolesRightsService: RolesRightsService,
    private exceptionLogService :ExceptionLogService
  ) { 

    // this.data = [
    //   {
    //     "name": "Germany",
    //     "value": 8940000
    //   },
    //   {
    //     "name": "USA",
    //     "value": 5000000
    //   },
    //   {
    //     "name": "France",
    //     "value": 7200000
    //   },
    //   {
    //     "name": "UK",
    //     "value": 6200000
    //   }
    // ];
  }  
  public ChartLabels:string[] = ['2012', '2013', '2014', '2015', '2016', '2017', '2018'];
  public ChartData:any[] = [
    {data: [55, 60, 75, 82, 56, 62, 80], label: 'Company A'},
    {data: [58, 55, 60, 79, 66, 57, 90], label: 'Company B'}
  ];


  public barChartOptions:any = {
    scaleShowVerticalLines: false,
    responsive: true
  };

    public mbarChartLabels:string[] = [];
    public barChartType:string = 'bar';
    public barChartLegend:boolean = true;
  
    public barChartColors:Array<any> = [
    {
      backgroundColor: 'rgba(105,159,177,0.2)',
      borderColor: 'rgba(105,159,177,1)',
      pointBackgroundColor: 'rgba(105,159,177,1)',
      pointBorderColor: '#fafafa',
      pointHoverBackgroundColor: '#fafafa',
      pointHoverBorderColor: 'rgba(105,159,177)'
    },
    { 
      backgroundColor: 'rgba(77,20,96,0.3)',
      borderColor: 'rgba(77,20,96,1)',
      pointBackgroundColor: 'rgba(77,20,96,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,20,96,1)'
    }
  ];
    public barChartData:any[] = [];
  
    // events
    public randomize(time,index):void {
      this.barChartButtons.forEach(element => {
        element.isClicked = false;
      });
      this.barChartButtons[index].isClicked = true;
      this.getChartData(time);
    }

  async ngOnInit() {
    this.spinner.show();
    this.isMg = localStorage.getItem('Theme') === 'mg';
     this.features = this.secureStorage.getKeyData('feature')
     if(!(this.features)){
      this.rolesRightsService.getFeatures().then((res)=>{
        if(res.responseObject.errorCount === 0){
          this.features = res.responseObject.result;
          this.HideFeatures()
        }
      })
     }
     else{
        this.HideFeatures()
     }
    this.WeeklyCount=[];this.MonthlyCount = [];
    if ( this.userService?.currentUserValue?.showLicenseKeyExpirationPopUp) {
      this.OpenLicenseKeyValidationPopUp();
    }

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'dealerId',
      textField: 'dealerName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      searchPlaceholderText: 'Search here',
      maxHeight: 500
    };

    this.userService.currentUser.subscribe(async resUser=>{
      if (resUser) {
        this.userRole = resUser.roleType;
        this.isDealerLoggedIn = this.userRole === fromEnums.UserRoles.DealerAdmin;
        this.isReceptionLoggedIn = this.userRole === fromEnums.UserRoles.Reception;
        this.isShowWidgetAppointmentRequests = !!resUser.userRoleMenuDetails.find(x => x.moduleId === fromEnums.ModuleNames.WidgetAppointment)?.canView;
        this.isShowDmsSyncErrors = !!resUser.userRoleMenuDetails.find(x => x.moduleId === fromEnums.ModuleNames.DMSSyncFailedlog)?.canView;
        this.isShowAfxSyncErrors = !!resUser.userRoleMenuDetails.find(x => x.moduleId === fromEnums.ModuleNames.AFXSyncFailedlog)?.canView;
        this.isShowDealers = !!resUser.userRoleMenuDetails.find(x => x.moduleId === fromEnums.ModuleNames.DealerDetails)?.canView;
        this.isShowUsers = !!resUser.userRoleMenuDetails.find(x => x.moduleId === fromEnums.ModuleNames.Reception)?.canView;
        this.isShowRentalCars = !!resUser.userRoleMenuDetails.find(x => x.moduleId === fromEnums.ModuleNames.RentalVehicle)?.canView;
        this.isShowContactUsers = !!resUser.userRoleMenuDetails.find(x => x.moduleId === fromEnums.ModuleNames.ContactUser)?.canView;
        this.isShowNumberOfDealerWithNoAppointment = !!resUser.userRoleMenuDetails.find(x => x.moduleId === fromEnums.ModuleNames.ShowDealerWithNoAppointment)?.canView;
        this.isShowExceptionLog = !!resUser.userRoleMenuDetails.find(x => x.moduleId === fromEnums.ModuleNames.SmartPlannerExceptionLog)?.canView;
        this.GetDealers(resUser.id); 
        await this.getCardCounts();
        this.getSyncCounts();
        this.barChartButtons.forEach(button => button.isClicked = false);
        this.barChartButtons[0].isClicked = true;
        await this.getChartData('1M');
      }
    });
    this.dashboardService.isFromDashboard = true;
    if(this.isShowNumberOfDealerWithNoAppointment){
      this.setDealerWithNoApppointmentInitialDate();
      await this.getDealerWithNoAppointments();
    }
    this.spinner.hide();
  }

  HideFeatures(){
    if(this.features.find(x => x.featureCode === fromEnums.FeatureCode.HideDashboardFeatures)?.isActive){
      this.HideDashboardFeatures = this.features.find(x => x.featureCode === fromEnums.FeatureCode.HideDashboardFeatures)?.param1;
      let featureArray = this.HideDashboardFeatures?.split(",");
      if(featureArray?.length > 0){
    featureArray?.forEach(ele => {
      switch(ele) { 
        case fromEnums.DashboardGridFeatures.DMS: { 
          this.DMSFeature = false; 
           break; 
        } 
        case fromEnums.DashboardGridFeatures.CheckIn: { 
          this.CheckInFeature = false; 
           break; 
        } 
        case fromEnums.DashboardGridFeatures.OrderValueInvoiceAmount: { 
          this.OrderInvoiceAmountFeature = false; 
           break; 
        } 
        case fromEnums.DashboardGridFeatures.WorkshopCapacity: { 
          this.WorkshopCapacityFeature = false; 
           break; 
        } 
        case fromEnums.DashboardGridFeatures.SmartPlanner: { 
          this.SmartPlannerFeature = false; 
           break; 
        } 
        case fromEnums.DashboardGridFeatures.Widget: { 
          this.WidgetFeature = false; 
           break; 
        }
        default: { 
           break; 
        } 
     } 
     })
    }
  }
}
  onTimeSelection(_time,index){
    this.buttons.forEach(element => {
      element.isClicked = false;
    });
    this.buttons[index].isClicked = true;
    switch(index) {
      case 0: {
        this.onOneDaySelection();
        break;
      }
      case 1: {
        this.onSevenDaySelection();
        break;
      }
      case 2: {
        this.onOneMonthSelection();
        break;
      }
      case 3: {
        this.onThreeMonthSelection();
        break;
      }
      case 4: {
        this.onSixMonthSelection();
        break;
      }
      case 5: {
        this.onOneYearSelection();
        break;
      }
      default: {
        this.onThreeMonthSelection();
         break;
      }
   }
}
onThreeMonthSelection(){
  this.SelectedData = [];
  let d = new Date();
  this.plannerTotal = 0;this.widgetTotal = 0; this.dmsTotal = 0; this.checkedInTotal = 0; this.invoiceAmountTotal = 0;this.serviceTime = 0;this.plannedTime = 0;this.allocatedTime = 0; this.olbBoTotal = 0;
  this.SelectedData = this.MonthlyCount.filter((_x,index) => index == d.getMonth() || index == d.getMonth()-1 || index == d.getMonth()-2);
  this.SelectedData.forEach(element => {
    this.plannerTotal += element.plannerCount;
    this.widgetTotal += element.widgetCount;
    this.dmsTotal += element.dmsCount;
    this.olbBoTotal += element.olbBoCount;
    this.checkedInTotal += element.checkedInCount;
    this.invoiceAmountTotal += element.invoiceAmountSum;
    element.serviceTime = parseFloat((element.serviceTime/60).toFixed(2));
    element.plannedTime = parseFloat((element.plannedTime/60).toFixed(2));
    element.allocatedTime = parseFloat((element.allocatedTime/60).toFixed(2));
    this.serviceTime += element.serviceTime;
    this.plannedTime += element.plannedTime;
    this.allocatedTime += element.allocatedTime;
  });
  this.serviceTime = parseFloat(this.serviceTime.toFixed(2));
  this.plannedTime = parseFloat(this.plannedTime.toFixed(2));
  this.allocatedTime = parseFloat(this.allocatedTime.toFixed(2));
}
onOneDaySelection(){
  this.SelectedData = [];
 let d = new Date();
 this.plannerTotal = 0;this.widgetTotal = 0; this.dmsTotal = 0; this.checkedInTotal = 0; this.invoiceAmountTotal = 0;this.serviceTime = 0;this.plannedTime = 0;this.allocatedTime = 0;this.olbBoTotal = 0;
 this.SelectedData = this.WeeklyCount.filter((_x,index) => index == d.getDay()-1);
 this.SelectedData.forEach(element => {
   this.plannerTotal += element.plannerCount;
   this.widgetTotal += element.widgetCount;
   this.dmsTotal += element.dmsCount;
   this.olbBoTotal += element.olbBoCount;
   this.checkedInTotal += element.checkedInCount;
   this.invoiceAmountTotal += element.invoiceAmountSum;
   element.serviceTime = parseFloat((element.serviceTime/60).toFixed(2));
   element.plannedTime = parseFloat((element.plannedTime/60).toFixed(2));
   element.allocatedTime = parseFloat((element.allocatedTime/60).toFixed(2));
   this.serviceTime += element.serviceTime;
   this.plannedTime += element.plannedTime;
   this.allocatedTime += element.allocatedTime;
 });
 this.serviceTime = parseFloat(this.serviceTime.toFixed(2));
 this.plannedTime = parseFloat(this.plannedTime.toFixed(2));
 this.allocatedTime = parseFloat(this.allocatedTime.toFixed(2));
}
onSevenDaySelection(){
  this.SelectedData = [];
 this.plannerTotal = 0;this.widgetTotal = 0; this.dmsTotal = 0; this.checkedInTotal = 0; this.invoiceAmountTotal = 0;this.serviceTime = 0;this.plannedTime = 0;this.allocatedTime = 0;this.olbBoTotal = 0;
 this.SelectedData = this.WeeklyCount;
 this.SelectedData.forEach(element => {
   this.plannerTotal += element.plannerCount;
   this.widgetTotal += element.widgetCount;
   this.dmsTotal += element.dmsCount;
   this.olbBoTotal += element.olbBoCount;
   this.checkedInTotal += element.checkedInCount;
   this.invoiceAmountTotal += element.invoiceAmountSum;
   element.serviceTime = parseFloat((element.serviceTime/60).toFixed(2));
   element.plannedTime = parseFloat((element.plannedTime/60).toFixed(2));
   element.allocatedTime = parseFloat((element.allocatedTime/60).toFixed(2));
   this.serviceTime += element.serviceTime;
   this.plannedTime += element.plannedTime;
   this.allocatedTime += element.allocatedTime;
 });
 this.serviceTime = parseFloat(this.serviceTime.toFixed(2));
 this.plannedTime = parseFloat(this.plannedTime.toFixed(2));
 this.allocatedTime = parseFloat(this.allocatedTime.toFixed(2));
}
onOneMonthSelection(){
 this.SelectedData = [];
 let d = new Date();
 this.plannerTotal = 0;this.widgetTotal = 0; this.dmsTotal = 0;this.checkedInTotal = 0;this.invoiceAmountTotal = 0;this.serviceTime = 0;this.plannedTime = 0;this.allocatedTime = 0;this.olbBoTotal = 0;
 this.SelectedData = this.MonthlyCount.filter((_x,index) => index == d.getMonth());
 this.SelectedData.forEach(element => {
   this.plannerTotal += element.plannerCount;
   this.widgetTotal += element.widgetCount;
   this.dmsTotal += element.dmsCount;
   this.olbBoTotal += element.olbBoCount;
   this.checkedInTotal += element.checkedInCount;
   this.invoiceAmountTotal += element.invoiceAmountSum;
   element.serviceTime = parseFloat((element.serviceTime/60).toFixed(2));
   element.plannedTime = parseFloat((element.plannedTime/60).toFixed(2));
   element.allocatedTime = parseFloat((element.allocatedTime/60).toFixed(2));
   this.serviceTime += element.serviceTime;
   this.plannedTime += element.plannedTime;
   this.allocatedTime += element.allocatedTime;
 });
 this.serviceTime = parseFloat(this.serviceTime.toFixed(2));
 this.plannedTime = parseFloat(this.plannedTime.toFixed(2));
 this.allocatedTime = parseFloat(this.allocatedTime.toFixed(2));
}
onSixMonthSelection(){
  this.SelectedData = [];
 let d = new Date();
 this.plannerTotal = 0;this.widgetTotal = 0; this.dmsTotal = 0;this.checkedInTotal = 0;this.invoiceAmountTotal = 0;this.serviceTime = 0;this.plannedTime = 0;this.allocatedTime = 0;this.olbBoTotal = 0;
 this.SelectedData = this.MonthlyCount.filter((_x,index) => index == d.getMonth() || index == d.getMonth()-1 || index == d.getMonth()-2 || index == d.getMonth()-3 || index == d.getMonth()-4 || index == d.getMonth()-5);
 this.SelectedData.forEach(element => {
   this.plannerTotal += element.plannerCount;
   this.widgetTotal += element.widgetCount;
   this.dmsTotal += element.dmsCount;
   this.olbBoTotal += element.olbBoCount;
   this.checkedInTotal += element.checkedInCount;
   this.invoiceAmountTotal += element.invoiceAmountSum;
   element.serviceTime = parseFloat((element.serviceTime/60).toFixed(2));
   element.plannedTime = parseFloat((element.plannedTime/60).toFixed(2));
   element.allocatedTime = parseFloat((element.allocatedTime/60).toFixed(2));
   this.serviceTime += element.serviceTime;
   this.plannedTime += element.plannedTime;
   this.allocatedTime += element.allocatedTime;
 });
 this.serviceTime = parseFloat(this.serviceTime.toFixed(2));
 this.plannedTime = parseFloat(this.plannedTime.toFixed(2));
 this.allocatedTime = parseFloat(this.allocatedTime.toFixed(2));
}
onOneYearSelection(){
  this.SelectedData = [];
  this.plannerTotal = 0;this.widgetTotal = 0; this.dmsTotal = 0;this.checkedInTotal = 0;this.invoiceAmountTotal = 0;this.serviceTime = 0;this.plannedTime = 0;this.allocatedTime = 0;this.olbBoTotal = 0;
  this.SelectedData = this.MonthlyCount;
  this.SelectedData.forEach(element => {
    this.plannerTotal += element.plannerCount;
    this.widgetTotal += element.widgetCount;
    this.dmsTotal += element.dmsCount;
    this.olbBoTotal += element.olbBoCount;
    this.checkedInTotal += element.checkedInCount;
    this.invoiceAmountTotal += element.invoiceAmountSum;
    element.serviceTime = parseFloat((element.serviceTime/60).toFixed(2));
    element.plannedTime = parseFloat((element.plannedTime/60).toFixed(2));
    element.allocatedTime = parseFloat((element.allocatedTime/60).toFixed(2));
    this.serviceTime += parseFloat(element.serviceTime.toFixed(2));
    this.plannedTime += element.plannedTime;
    this.allocatedTime += element.allocatedTime;
  });
  this.serviceTime = parseFloat(this.serviceTime.toFixed(2));
  this.plannedTime = parseFloat(this.plannedTime.toFixed(2));
  this.allocatedTime = parseFloat(this.allocatedTime.toFixed(2));
}


  SetDMSToPlannerFlag(displayName) {
    if(displayName == "lblTodayDmsLog"){
      this.logService.filterTypeId = 1;
    }
    if( displayName == "lblWeeklyDmsLog"){
      this.logService.filterTypeId = 2;
    }
    this.dashboardService.isFromDashboard = true;
    this.DMSToPlanner();
  }

  SetPlannerToDMSFlag(displayName){
    if(displayName == "lblTodayDmsLog"){
      this.logService.filterTypeId = 1;
    }
    if( displayName == "lblWeeklyDmsLog"){
      this.logService.filterTypeId = 2;
    }
    this.dashboardService.isFromDashboard = true;
    this.PlannerToDMS();
  }

  SetExceptionLogFlag(displayName: string) {
    let viewType = displayName === "weeklog" ? 2 : 1;
    this.exceptionLogService.changeViewType(viewType);
    this.dashboardService.isFromDashboard = true;
    this.ExceptionLog(); 
  }

  getSyncCounts(){
    this.dashboardService.getSyncCounts().then(response => {
      if(response){
        this.SyncCounts = response;
      }
    })
  }

   async getCardCounts() {
    this.spinner.show();
    let model = {
      dealerId: this.userService.currentUserValue.dealerId,
      languageCode: this.cookieservice.get('userSelectedLanguage'),
      selectedDealers: this.selectedDealers.map(x =>x.dealerId)
    };
    await this.dashboardService.getCardCounts(model).then(response => {
      if (response) {
        this.dashboardDetail = response;
        this.cardCounts = this.dashboardDetail.cardCountViewModel;
        this.cardList = this.dashboardDetail.cardDetailViewModels;
        this.MonthlyCount = [];
        this.WeeklyCount = [];
        this.MonthlyCount.push({name: this.monthNames[0],plannerCount:parseInt(this.cardCounts.month1Count.split(',')[0]),widgetCount:parseInt(this.cardCounts.month1Count.split(',')[1]),dmsCount:parseInt(this.cardCounts.month1Count.split(',')[2]),checkedInCount:parseInt(this.cardCounts.month1Count.split(',')[3]),invoiceAmountSum:parseFloat(this.cardCounts.month1Count.split(',')[4]),serviceTime:parseFloat(this.cardCounts.month1Count.split(',')[5]),plannedTime:parseFloat(this.cardCounts.month1Count.split(',')[6]),allocatedTime:parseFloat(this.cardCounts.month1Count.split(',')[7]),olbBoCount:parseFloat(this.cardCounts.month1Count.split(',')[8])});
        this.MonthlyCount.push({name: this.monthNames[1],plannerCount:parseInt(this.cardCounts.month2Count.split(',')[0]),widgetCount:parseInt(this.cardCounts.month2Count.split(',')[1]),dmsCount:parseInt(this.cardCounts.month2Count.split(',')[2]),checkedInCount:parseInt(this.cardCounts.month2Count.split(',')[3]),invoiceAmountSum:parseFloat(this.cardCounts.month2Count.split(',')[4]),serviceTime:parseFloat(this.cardCounts.month2Count.split(',')[5]),plannedTime:parseFloat(this.cardCounts.month2Count.split(',')[6]),allocatedTime:parseFloat(this.cardCounts.month2Count.split(',')[7]),olbBoCount:parseFloat(this.cardCounts.month2Count.split(',')[8])});
        this.MonthlyCount.push({name: this.monthNames[2],plannerCount:parseInt(this.cardCounts.month3Count.split(',')[0]),widgetCount:parseInt(this.cardCounts.month3Count.split(',')[1]),dmsCount:parseInt(this.cardCounts.month3Count.split(',')[2]),checkedInCount:parseInt(this.cardCounts.month3Count.split(',')[3]),invoiceAmountSum:parseFloat(this.cardCounts.month3Count.split(',')[4]),serviceTime:parseFloat(this.cardCounts.month3Count.split(',')[5]),plannedTime:parseFloat(this.cardCounts.month3Count.split(',')[6]),allocatedTime:parseFloat(this.cardCounts.month3Count.split(',')[7]),olbBoCount:parseFloat(this.cardCounts.month3Count.split(',')[8])});
        this.MonthlyCount.push({name: this.monthNames[3],plannerCount:parseInt(this.cardCounts.month4Count.split(',')[0]),widgetCount:parseInt(this.cardCounts.month4Count.split(',')[1]),dmsCount:parseInt(this.cardCounts.month4Count.split(',')[2]),checkedInCount:parseInt(this.cardCounts.month4Count.split(',')[3]),invoiceAmountSum:parseFloat(this.cardCounts.month4Count.split(',')[4]),serviceTime:parseFloat(this.cardCounts.month4Count.split(',')[5]),plannedTime:parseFloat(this.cardCounts.month4Count.split(',')[6]),allocatedTime:parseFloat(this.cardCounts.month4Count.split(',')[7]),olbBoCount:parseFloat(this.cardCounts.month4Count.split(',')[8])});
        this.MonthlyCount.push({name: this.monthNames[4],plannerCount:parseInt(this.cardCounts.month5Count.split(',')[0]),widgetCount:parseInt(this.cardCounts.month5Count.split(',')[1]),dmsCount:parseInt(this.cardCounts.month5Count.split(',')[2]),checkedInCount:parseInt(this.cardCounts.month5Count.split(',')[3]),invoiceAmountSum:parseFloat(this.cardCounts.month5Count.split(',')[4]),serviceTime:parseFloat(this.cardCounts.month5Count.split(',')[5]),plannedTime:parseFloat(this.cardCounts.month5Count.split(',')[6]),allocatedTime:parseFloat(this.cardCounts.month5Count.split(',')[7]),olbBoCount:parseFloat(this.cardCounts.month5Count.split(',')[8])});
        this.MonthlyCount.push({name: this.monthNames[5],plannerCount:parseInt(this.cardCounts.month6Count.split(',')[0]),widgetCount:parseInt(this.cardCounts.month6Count.split(',')[1]),dmsCount:parseInt(this.cardCounts.month6Count.split(',')[2]),checkedInCount:parseInt(this.cardCounts.month6Count.split(',')[3]),invoiceAmountSum:parseFloat(this.cardCounts.month6Count.split(',')[4]),serviceTime:parseFloat(this.cardCounts.month6Count.split(',')[5]),plannedTime:parseFloat(this.cardCounts.month6Count.split(',')[6]),allocatedTime:parseFloat(this.cardCounts.month6Count.split(',')[7]),olbBoCount:parseFloat(this.cardCounts.month6Count.split(',')[8])});
        this.MonthlyCount.push({name: this.monthNames[6],plannerCount:parseInt(this.cardCounts.month7Count.split(',')[0]),widgetCount:parseInt(this.cardCounts.month7Count.split(',')[1]),dmsCount:parseInt(this.cardCounts.month7Count.split(',')[2]),checkedInCount:parseInt(this.cardCounts.month7Count.split(',')[3]),invoiceAmountSum:parseFloat(this.cardCounts.month7Count.split(',')[4]),serviceTime:parseFloat(this.cardCounts.month7Count.split(',')[5]),plannedTime:parseFloat(this.cardCounts.month7Count.split(',')[6]),allocatedTime:parseFloat(this.cardCounts.month7Count.split(',')[7]),olbBoCount:parseFloat(this.cardCounts.month7Count.split(',')[8])});
        this.MonthlyCount.push({name: this.monthNames[7],plannerCount:parseInt(this.cardCounts.month8Count.split(',')[0]),widgetCount:parseInt(this.cardCounts.month8Count.split(',')[1]),dmsCount:parseInt(this.cardCounts.month8Count.split(',')[2]),checkedInCount:parseInt(this.cardCounts.month8Count.split(',')[3]),invoiceAmountSum:parseFloat(this.cardCounts.month8Count.split(',')[4]),serviceTime:parseFloat(this.cardCounts.month8Count.split(',')[5]),plannedTime:parseFloat(this.cardCounts.month8Count.split(',')[6]),allocatedTime:parseFloat(this.cardCounts.month8Count.split(',')[7]),olbBoCount:parseFloat(this.cardCounts.month8Count.split(',')[8])});
        this.MonthlyCount.push({name: this.monthNames[8],plannerCount:parseInt(this.cardCounts.month9Count.split(',')[0]),widgetCount:parseInt(this.cardCounts.month9Count.split(',')[1]),dmsCount:parseInt(this.cardCounts.month9Count.split(',')[2]),checkedInCount:parseInt(this.cardCounts.month9Count.split(',')[3]),invoiceAmountSum:parseFloat(this.cardCounts.month9Count.split(',')[4]),serviceTime:parseFloat(this.cardCounts.month9Count.split(',')[5]),plannedTime:parseFloat(this.cardCounts.month9Count.split(',')[6]),allocatedTime:parseFloat(this.cardCounts.month9Count.split(',')[7]),olbBoCount:parseFloat(this.cardCounts.month9Count.split(',')[8])});
        this.MonthlyCount.push({name: this.monthNames[9],plannerCount:parseInt(this.cardCounts.month10Count.split(',')[0]),widgetCount:parseInt(this.cardCounts.month10Count.split(',')[1]),dmsCount:parseInt(this.cardCounts.month10Count.split(',')[2]),checkedInCount:parseInt(this.cardCounts.month10Count.split(',')[3]),invoiceAmountSum:parseFloat(this.cardCounts.month10Count.split(',')[4]),serviceTime:parseFloat(this.cardCounts.month10Count.split(',')[5]),plannedTime:parseFloat(this.cardCounts.month10Count.split(',')[6]),allocatedTime:parseFloat(this.cardCounts.month10Count.split(',')[7]),olbBoCount:parseFloat(this.cardCounts.month10Count.split(',')[8])});
        this.MonthlyCount.push({name: this.monthNames[10],plannerCount:parseInt(this.cardCounts.month11Count.split(',')[0]),widgetCount:parseInt(this.cardCounts.month11Count.split(',')[1]),dmsCount:parseInt(this.cardCounts.month11Count.split(',')[2]),checkedInCount:parseInt(this.cardCounts.month11Count.split(',')[3]),invoiceAmountSum:parseFloat(this.cardCounts.month11Count.split(',')[4]),serviceTime:parseFloat(this.cardCounts.month11Count.split(',')[5]),plannedTime:parseFloat(this.cardCounts.month11Count.split(',')[6]),allocatedTime:parseFloat(this.cardCounts.month11Count.split(',')[7]),olbBoCount:parseFloat(this.cardCounts.month11Count.split(',')[8])});
        this.MonthlyCount.push({name: this.monthNames[11],plannerCount:parseInt(this.cardCounts.month12Count.split(',')[0]),widgetCount:parseInt(this.cardCounts.month12Count.split(',')[1]),dmsCount:parseInt(this.cardCounts.month12Count.split(',')[2]),checkedInCount:parseInt(this.cardCounts.month12Count.split(',')[3]),invoiceAmountSum:parseFloat(this.cardCounts.month12Count.split(',')[4]),serviceTime:parseFloat(this.cardCounts.month12Count.split(',')[5]),plannedTime:parseFloat(this.cardCounts.month12Count.split(',')[6]),allocatedTime:parseFloat(this.cardCounts.month12Count.split(',')[7]),olbBoCount:parseFloat(this.cardCounts.month12Count.split(',')[8])});
        this.WeeklyCount.push({name: this.dayNames[0],plannerCount:parseInt(this.cardCounts.day1Count.split(',')[0]),widgetCount:parseInt(this.cardCounts.day1Count.split(',')[1]),dmsCount:parseInt(this.cardCounts.day1Count.split(',')[2]),checkedInCount:parseInt(this.cardCounts.day1Count.split(',')[3]),invoiceAmountSum:parseFloat(this.cardCounts.day1Count.split(',')[4]),serviceTime:parseFloat(this.cardCounts.day1Count.split(',')[5]),plannedTime:parseFloat(this.cardCounts.day1Count.split(',')[6]),allocatedTime:parseFloat(this.cardCounts.day1Count.split(',')[7]), olbBoCount:parseFloat(this.cardCounts.day1Count.split(',')[8])});
        this.WeeklyCount.push({name: this.dayNames[1],plannerCount:parseInt(this.cardCounts.day2Count.split(',')[0]),widgetCount:parseInt(this.cardCounts.day2Count.split(',')[1]),dmsCount:parseInt(this.cardCounts.day2Count.split(',')[2]),checkedInCount:parseInt(this.cardCounts.day2Count.split(',')[3]),invoiceAmountSum:parseFloat(this.cardCounts.day2Count.split(',')[4]), serviceTime:parseFloat(this.cardCounts.day2Count.split(',')[5]), plannedTime:parseFloat(this.cardCounts.day2Count.split(',')[6]),allocatedTime:parseFloat(this.cardCounts.day2Count.split(',')[7]), olbBoCount:parseFloat(this.cardCounts.day2Count.split(',')[8])});
        this.WeeklyCount.push({name: this.dayNames[2],plannerCount:parseInt(this.cardCounts.day3Count.split(',')[0]),widgetCount:parseInt(this.cardCounts.day3Count.split(',')[1]),dmsCount:parseInt(this.cardCounts.day3Count.split(',')[2]),checkedInCount:parseInt(this.cardCounts.day3Count.split(',')[3]),invoiceAmountSum:parseFloat(this.cardCounts.day3Count.split(',')[4]), serviceTime:parseFloat(this.cardCounts.day3Count.split(',')[5]),plannedTime:parseFloat(this.cardCounts.day3Count.split(',')[6]),allocatedTime:parseFloat(this.cardCounts.day3Count.split(',')[7]), olbBoCount:parseFloat(this.cardCounts.day3Count.split(',')[8])});
        this.WeeklyCount.push({name: this.dayNames[3],plannerCount:parseInt(this.cardCounts.day4Count.split(',')[0]),widgetCount:parseInt(this.cardCounts.day4Count.split(',')[1]),dmsCount:parseInt(this.cardCounts.day4Count.split(',')[2]),checkedInCount:parseInt(this.cardCounts.day4Count.split(',')[3]),invoiceAmountSum:parseFloat(this.cardCounts.day4Count.split(',')[4]), serviceTime:parseFloat(this.cardCounts.day4Count.split(',')[5]),plannedTime:parseFloat(this.cardCounts.day4Count.split(',')[6]),allocatedTime:parseFloat(this.cardCounts.day4Count.split(',')[7]), olbBoCount:parseFloat(this.cardCounts.day4Count.split(',')[8])});
        this.WeeklyCount.push({name: this.dayNames[4],plannerCount:parseInt(this.cardCounts.day5Count.split(',')[0]),widgetCount:parseInt(this.cardCounts.day5Count.split(',')[1]),dmsCount:parseInt(this.cardCounts.day5Count.split(',')[2]),checkedInCount:parseInt(this.cardCounts.day5Count.split(',')[3]),invoiceAmountSum:parseFloat(this.cardCounts.day5Count.split(',')[4]), serviceTime:parseFloat(this.cardCounts.day5Count.split(',')[5]),plannedTime:parseFloat(this.cardCounts.day5Count.split(',')[6]),allocatedTime:parseFloat(this.cardCounts.day5Count.split(',')[7]), olbBoCount:parseFloat(this.cardCounts.day5Count.split(',')[8])});
        this.WeeklyCount.push({name: this.dayNames[5],plannerCount:parseInt(this.cardCounts.day6Count.split(',')[0]),widgetCount:parseInt(this.cardCounts.day6Count.split(',')[1]),dmsCount:parseInt(this.cardCounts.day6Count.split(',')[2]),checkedInCount:parseInt(this.cardCounts.day6Count.split(',')[3]),invoiceAmountSum:parseFloat(this.cardCounts.day6Count.split(',')[4]), serviceTime:parseFloat(this.cardCounts.day6Count.split(',')[5]),plannedTime:parseFloat(this.cardCounts.day6Count.split(',')[6]),allocatedTime:parseFloat(this.cardCounts.day6Count.split(',')[7]), olbBoCount:parseFloat(this.cardCounts.day6Count.split(',')[8])});
        this.WeeklyCount.push({name: this.dayNames[6],plannerCount:parseInt(this.cardCounts.day7Count.split(',')[0]),widgetCount:parseInt(this.cardCounts.day7Count.split(',')[1]),dmsCount:parseInt(this.cardCounts.day7Count.split(',')[2]),checkedInCount:parseInt(this.cardCounts.day7Count.split(',')[3]),invoiceAmountSum:parseFloat(this.cardCounts.day7Count.split(',')[4]), serviceTime:parseFloat(this.cardCounts.day7Count.split(',')[5]),plannedTime:parseFloat(this.cardCounts.day7Count.split(',')[6]),allocatedTime:parseFloat(this.cardCounts.day7Count.split(',')[7]), olbBoCount:parseFloat(this.cardCounts.day7Count.split(',')[8])});

        let index = this.buttons.findIndex(x => x.isClicked);
        switch(index) {
          case 0: {
            this.onOneDaySelection();
            break;
          }
          case 1: {
            this.onSevenDaySelection();
            break;
          }
          case 2: {
            this.onOneMonthSelection();
            break;
          }
          case 3: {
            this.onThreeMonthSelection();
            break;
          }
          case 4: {
            this.onSixMonthSelection();
            break;
          }
          case 5: {
            this.onOneYearSelection();
            break;
          }
          default: {
            this.onThreeMonthSelection();
             break;
          }
       }
        //Adding data in one card in pair of 2
        let groups = [...new Set(this.cardList?.map(a => a.groupId))];
        groups.forEach((gid) => {
          let row = [];
          row = this.cardList.filter(x => x.groupId == gid);
          this.cardRows.push(row);
        });

        this.cardRows.forEach(c => {
          c.forEach((x: { moduleId: any; route: string; }) => {
            switch (x.moduleId) {
              case fromEnums.ModuleNames.Mechanic:
                x.route = '/mechanic';
                break;
              case fromEnums.ModuleNames.DealerDetails:
                x.route = '/dealer';
                break;
              case fromEnums.ModuleNames.Service:
                x.route = '/services';
                break;
              case fromEnums.ModuleNames.ServiceCategory:
                x.route = '/service-categories';
                break;
              case fromEnums.ModuleNames.Vehicle:
                x.route = '/vehicle';
                break;
              case fromEnums.ModuleNames.RentalVehicle:
                x.route = '/rentalvehicle';
                break;
              case fromEnums.ModuleNames.Parts:
                x.route = '/parts';
                break;
              case fromEnums.ModuleNames.SpecialTools:
                x.route = '/specialTool';
                break;
              case fromEnums.ModuleNames.DealerParts:
                x.route = '/dealerparts';
                break;
              case fromEnums.ModuleNames.DealerService:
                x.route = '/dealer-service';
                break;
              case fromEnums.ModuleNames.DealerSpecialTools:
                x.route = '/dealerSpecialTool';
                break;
              case fromEnums.ModuleNames.Brand:
                x.route = '/brand';
                break;
              case fromEnums.ModuleNames.Reception:
                x.route = '/user';
                break;
              case fromEnums.ModuleNames.Customer:
                x.route = '/customer';
                break;
              case fromEnums.ModuleNames.DMSSyncFailedlog:
                x.route = '/dms-syncfailedlog';
                break;
              default:
                break;
            }
          });
        })
      }
    })
    if (this.secureStorage.getKeyData('feature')) {
      this.features = this.secureStorage.getKeyData('feature');
      this.isDmsAppointmentActive = this.features.find(x => x.featureCode === fromEnums.FeatureCode.DmsAppointment)?.isActive
      if (this.features?.length > 0) {
        if((this.features.find(x => x.featureCode === fromEnums.FeatureCode.RenatlCar)?.isActive === true) && (this.features.find(x=>x.featureCode === fromEnums.FeatureCode.GRentalCar)?.isActive === false))
        {
          this.isRentalService = true;
        }
        else{
          this.isRentalService = false;
        }
      }
    }
    if (!this.isRentalService) {
      this.cardRows.forEach((element, index) => {
        element.forEach((val) => {
          if (val.moduleId === fromEnums.ModuleNames.RentalVehicle) {
            this.cardRows.splice(index, 1);
          }
        });
      });
    }
    this.spinner.hide();
  }

  ClickOnTomorrow(day: string) {
    if (day == "tomorrow") {
      this.appointmentService.dateFlag = 1;
      let dateObject = {
        beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy'),
        endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy')
      };
      let bookingDate = dateObject.beginDate + ' - ' + dateObject.endDate;
      this.appointmentService.appointmentRequestModel.bookingDate = bookingDate;
      this.appointmentService.AppointmentDay = fromEnums.AppointmentDay.TomorrowAppointment
    }
    else {
      this.appointmentService.dateFlag = 0;
      let dateObject = {
        beginDate: this.datepipe.transform(new Date(), 'dd/MM/yyyy'),
        endDate: this.datepipe.transform(new Date(), 'dd/MM/yyyy')
      };
      let bookingDate = dateObject.beginDate + ' - ' + dateObject.endDate;
      this.appointmentService.appointmentRequestModel.bookingDate = bookingDate;
      this.appointmentService.AppointmentDay = fromEnums.AppointmentDay.TodayAppointment
    }
    this.router.navigate([`/appointment`]);
  }
  GetCheckInData(day: string) {
    if (day == "tomorrow") {
      this.appointmentService.dateFlag = 1;
      let dateObject = {
        beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy'),
        endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy')
      };
      let bookingDate = dateObject.beginDate + ' - ' + dateObject.endDate;
      this.appointmentService.appointmentRequestModel.bookingDate = bookingDate;
      this.appointmentService.appointmentRequestModel.appointmentStatusId = fromEnums.AppointmentStatus.CheckedIn;
      this.appointmentService.AppointmentDay = fromEnums.AppointmentDay.TomorrowCheckedInAppointment
    }
    else {
      this.appointmentService.dateFlag = 0;
      let dateObject = {
        beginDate: this.datepipe.transform(new Date(), 'dd/MM/yyyy'),
        endDate: this.datepipe.transform(new Date(), 'dd/MM/yyyy')
      };
      let bookingDate = dateObject.beginDate + ' - ' + dateObject.endDate;
      this.appointmentService.appointmentRequestModel.bookingDate = bookingDate;
      this.appointmentService.appointmentRequestModel.appointmentStatusId = fromEnums.AppointmentStatus.CheckedIn;
      this.appointmentService.AppointmentDay = fromEnums.AppointmentDay.TodayCheckedInAppointment
    }


    this.router.navigate([`/appointment`]);
  }
  GetNotCheckInData(day: string) {
    if (day == "tomorrow") {
      this.appointmentService.dateFlag = 1;
      let dateObject = {
        beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy'),
        endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy')
      };
      let bookingDate = dateObject.beginDate + ' - ' + dateObject.endDate;
      this.appointmentService.appointmentRequestModel.bookingDate = bookingDate;
      this.appointmentService.appointmentRequestModel.appointmentStatusId = fromEnums.AppointmentStatus.Confirmed;
      this.appointmentService.AppointmentDay = fromEnums.AppointmentDay.TomorrowNotCheckedInAppointment
    }
    else {
      this.appointmentService.dateFlag = 0;
      let dateObject = {
        beginDate: this.datepipe.transform(new Date(), 'dd/MM/yyyy'),
        endDate: this.datepipe.transform(new Date(), 'dd/MM/yyyy')
      };
      let bookingDate = dateObject.beginDate + ' - ' + dateObject.endDate;
      this.appointmentService.appointmentRequestModel.bookingDate = bookingDate;
      this.appointmentService.appointmentRequestModel.appointmentStatusId = fromEnums.AppointmentStatus.Confirmed;
      this.appointmentService.AppointmentDay = fromEnums.AppointmentDay.TodayNotCheckedInAppointment
    }


    this.router.navigate([`/appointment`]);
  }
  GetCancelledAppointmentData(day: string) {
    if (day == "tomorrow") {
      this.appointmentService.dateFlag = 1;
      let dateObject = {
        beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy'),
        endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy')
      };
      let bookingDate = dateObject.beginDate + ' - ' + dateObject.endDate;
      this.appointmentService.appointmentRequestModel.bookingDate = bookingDate;
      this.appointmentService.appointmentRequestModel.appointmentStatusId = fromEnums.AppointmentStatus.Cancelled;
      this.appointmentService.AppointmentDay = fromEnums.AppointmentDay.TomorrowCancelledAppointment

    }
    else {
      this.appointmentService.dateFlag = 0;
      let dateObject = {
        beginDate: this.datepipe.transform(new Date(), 'dd/MM/yyyy'),
        endDate: this.datepipe.transform(new Date(), 'dd/MM/yyyy')
      };
      let bookingDate = dateObject.beginDate + ' - ' + dateObject.endDate;
      this.appointmentService.appointmentRequestModel.bookingDate = bookingDate;
      this.appointmentService.appointmentRequestModel.appointmentStatusId = fromEnums.AppointmentStatus.Cancelled;
      this.appointmentService.AppointmentDay = fromEnums.AppointmentDay.TodayCancelledAppointment
    }
    this.router.navigate([`/appointment`]);
  }

  OpenLicenseKeyValidationPopUp(): void {
    let data = {
      expirationDate: this.userService.currentUserValue.licenseKeyExpirationDate,
      isKeyExpired: this.userService.currentUserValue.isLicenseKeyExpired
    };

    const modalref = this.modalService.open(LicenseKeyValidationComponent, {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'warningPopup'
    });
    modalref.componentInstance.licenseKeyData = data;
  }

  async GetDealers(userId){
    this.dealerList = await this.dashboardService.GetDealers(userId);
    
    // Set default dealer if available
    const defaultDealerId = this.userService.currentUserValue.defaultDealerId;
    if (defaultDealerId && this.dealerList) {
      const defaultDealer = this.dealerList.find(dealer => dealer.dealerId === defaultDealerId);
      if (defaultDealer) {
        this.selectedDealers = [defaultDealer];
      }
    }
  }

  onChangeDealer(_event: any){
    setTimeout(async () => {
      await this.getCardCounts();
      await this.getChartData(this.SelectMonthBrandWiseAppointment);
      this.appointmentService.appointmentRequestModel.dealerId = this.selectedDealers[0]?.dealerId ? this.selectedDealers[0]?.dealerId : this.appointmentService.appointmentRequestModel.dealerId ;
    });
  }

  DMSToPlanner(){
    this.router.navigate(['/dms-syncfailedlog']);
  }

  PlannerToDMS(){
    this.router.navigate(['/afx-syncfailedlog']);
  }

  ExceptionLog() {
    this.router.navigate(['/exception-log']);
  }
  
  ActiveDealers() {
    this.router.navigate(['/dealer']);
  }

  ActiveUsers(){
    this.router.navigate(['/user']);
  }

  RentalVehicle(){
    this.router.navigate(['/rentalvehicle']);
  }
  ContactUsers(){
    this.router.navigate(['/checkin-customer-connect']);
  }

  WidgetAppointment(status){
    this.dashboardService.isFromDashboard = true;
    this.dashboardService.WidgetAppointmentStatus = status;
    this.router.navigate(['/widget-appointment'])
  }
  async getChartData(text){
    this.spinner.show();
    this.SelectMonthBrandWiseAppointment = text;
    let month = (+text.charAt(0) - 1);
    const lastDate = this.getLastDateOfCurrentMonth();
    const firstDate = this.getFirstDateOfGivenMonth(new Date().getFullYear(), (new Date().getMonth())- month);
    let model = {
      fromDate: firstDate.toDateString(),
      toDate: lastDate.toDateString(),
      selectedDealers: this.selectedDealers.map(x =>x.dealerId)
    };
    await this.dashboardService.getBrandWiseAppointment(model).then(response => {
     if(response.responseObject != null && response.responseObject?.length > 0){
      this.barChartData = response.responseObject;
      const monthList = this.getMonthList((month + 1), firstDate.getMonth());
      this.mbarChartLabels = monthList;
     }else{
      this.barChartData= [];
      this.mbarChartLabels = [];
     }
    }).finally(()=>{
      this.spinner.hide();
    });
  }
  getLastDateOfCurrentMonth(): Date {
    const now = new Date(); // Get the current date
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth();

    // Create a new date object set to the first day of the next month
    const firstDayOfNextMonth = new Date(currentYear, currentMonth + 1, 1);

    // Subtract one day to get the last day of the current month
    const lastDateOfCurrentMonth = new Date(firstDayOfNextMonth.getTime() - 1);

    return lastDateOfCurrentMonth;
}

 getFirstDateOfGivenMonth(year: number, month: number): Date {
  // Create a new Date object set to the first day of the given month
  // Note: month is 0-based (January is 0, February is 1, etc.)
  const firstDate = new Date(year, month, 1);

  return firstDate;
}

 getMonthList(numberOfMonths: number, startMonth: number = 0): string[] {
  const monthNames = [
      'January' , 'February' , 'March' , 'April' , 'May' , 'June' ,
      'July' , 'August', 'September' , 'October' , 'November' , 'December' 
  ];

  if (numberOfMonths < 1 || numberOfMonths > 12 || startMonth < 0 || startMonth > 11) {
      throw new Error('Invalid number of months or start month');
  }

  // Calculate the ending index
  const endMonth = (startMonth + numberOfMonths) % 12;

  // Generate a list of month names based on the number of months and starting point
  if (endMonth > startMonth) {
      return monthNames.slice(startMonth, startMonth + numberOfMonths);
  } else {
      // Wrap around the end of the year
      return monthNames.slice(startMonth).concat(monthNames.slice(0, endMonth));
  }
}


async onDateDealerWithNoAppointmentRangeChanged(event: any) {
  this.selectedDealerWithNoAppointmentDate = (typeof event === 'undefined') ? [] : event;
  if(this.selectedDealerWithNoAppointmentDate.length == 0){
    this.onDateDealerWithNoAppointmentSelectionCleared();
  }
}

onDateDealerWithNoAppointmentSelectionCleared() {
  this.dealersCountWithAppointments = 0;
  this.dealersCountWithNoAppointments = 0;
  this.dealersAppointmentCountList = [];
}

setDealerWithNoApppointmentInitialDate() {
  let todayDate = new Date();
  
  this.selectedDealerWithNoAppointmentDate.push(todayDate);
  this.selectedDealerWithNoAppointmentDate.push(todayDate);
}


async getDealerWithNoAppointments(){
  let selectedDealerWithNoAppointmentDateFormatted= this.getFormattedDate(this.selectedDealerWithNoAppointmentDate);
  this.spinner.show();
  this.onDateDealerWithNoAppointmentSelectionCleared();
  await this.dashboardService.getDealerWithNoAppointments(selectedDealerWithNoAppointmentDateFormatted).then(response => {
   if(response != null && response?.length > 0){
    this.dealersAppointmentCountList = response;
    //Get distinctDealerCount with Appointment;
    let dealerWithAppointment = this.dealersAppointmentCountList.filter(x=>x.appointmentCount > 0);
   // Create a Set to store unique dealer names
    const uniqueWithAppointmentDealerNames = new Set<string>();
    dealerWithAppointment.forEach(element => {
      uniqueWithAppointmentDealerNames.add(element.dealerName);
    });
    this.dealersCountWithAppointments = uniqueWithAppointmentDealerNames.size;
   
    //Get distinctDealerCount without Appointment;
    let dealerWithOutAppointment = this.dealersAppointmentCountList.filter(x=>x.appointmentCount == 0);
   // Create a Set to store unique dealer names
    const uniqueWithOutAppointmentDealerNames = new Set<string>();
    dealerWithOutAppointment.forEach(element => {
      uniqueWithOutAppointmentDealerNames.add(element.dealerName);
    });
    this.dealersCountWithNoAppointments = uniqueWithOutAppointmentDealerNames.size;
   }
  }).finally(()=>{
    this.spinner.hide();
  });
}
public async exportDealerWithNoAppointmentAsXLSX() {
  if(this.dealersAppointmentCountList.length > 0){
    this.spinner.show();
    const dataToExport = this.dealersAppointmentCountList.filter(f=>f.appointmentCount == 0);
    if (dataToExport && dataToExport.length > 0) {
      const excelData = this.mapDataDealerAppointmentForExport(dataToExport);
      this.excelService.exportAsExcelFile(excelData, 'Dealer_Count_With_No_Appointment');
    } else {
      this.toaster.warning(this.translate.instant('lblNotAvailable'));
    }
    this.spinner.hide();
  }
}
public async exportDealerWithAppointmentAsXLSX() {
  if(this.dealersAppointmentCountList.length > 0){
    this.spinner.show();
    const dataToExport = this.dealersAppointmentCountList.filter(f=>f.appointmentCount > 0);
    if (dataToExport && dataToExport.length > 0) {
      const excelData = this.mapDataDealerAppointmentForExport(dataToExport);
      this.excelService.exportAsExcelFile(excelData, 'Dealer_Count_With_Appointment');
    } else {
      this.toaster.warning(this.translate.instant('lblNotAvailable'));
    }
    this.spinner.hide();
  }
}
private mapDataDealerAppointmentForExport(data): any[] {
  if(this.isMg){
    return data.map((item, index) => ({
      [this.translate.instant('lblNo')]: index + 1,
      [this.translate.instant('lblDealerName')]: item.dealerName,
      [this.translate.instant('lblDealerDmsNo')]: item.dealerDmsNo,
      [this.translate.instant('lblYearMonth')]: item.monthYear,
      [this.translate.instant('lblAppointmentCount')]: item.appointmentCount,
    }));
  }else{
    return data.map((item, index) => ({
      [this.translate.instant('lblNo')]: index + 1,
      [this.translate.instant('lblDealerName')]: item.dealerName,
      [this.translate.instant('lblYearMonth')]: item.monthYear,
      [this.translate.instant('lblAppointmentCount')]: item.appointmentCount,
    }));
  }
}
getFormattedDate(dateRangeArray: any[]){
  let formattedDate: string= "";
  if(dateRangeArray.length != 0){
    let beginDate= this.datepipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
    let lastDate= this.datepipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
    formattedDate= beginDate + ' - ' + lastDate;
  }
  return formattedDate;
}
}
